/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module misc {
  'use strict';
  
  export class SigristHistoryCtrl {

    public static $inject = [
      '$scope'
      , '$timeout'
      , '$interval'
    ];

    constructor(
      private $scope: any
      , private $timeout: ng.ITimeoutService
      , private $interval: ng.IIntervalService
      ) {

      $scope.vm = this;
      $scope.testimonialIndex = 0;
      $scope.jubiIndex = 0;

      $scope.interval = $interval(() => { this.checkPageChange(); }, 200);
      $scope.intervalJubi = $interval(() => { this.checkPageChangeJubi(); }, 200);

      $scope.lastChange = new Date().getTime();
      $scope.lastChangeJubi = new Date().getTime();

      $scope.$watch("testimonialIndex", () => {
        // timeout so that the model changes when it's invisible for the user
        if ($scope.historyData) $timeout(() => { $scope.entry = $scope.historyData[$scope.testimonialIndex]; }, 200);
      });

      $scope.$watch("jubiIndex", () => {
        // timeout so that the model changes when it's invisible for the user
        if ($scope.jubiData) $timeout(() => { $scope.entryJubi = $scope.jubiData[$scope.jubiIndex]; }, 200);
      });
    }

    waitTime: number = 15000;

    public init(data :  any) {
      this.$scope.historyData = data;
      if (this.$scope.historyData) this.$scope.entry = this.$scope.historyData[0];
    }

    public initJubi(data: any) {
      this.$scope.jubiData = data;
      if (this.$scope.jubiData) this.$scope.entryJubi = this.$scope.jubiData[0];
    }

    public next() {
      $("#testimonialCarrousel").parent().removeClass("anim-to-right");
      $("#testimonialCarrousel").parent().addClass("anim-to-left");
      if (this.$scope.testimonialIndex >= this.$scope.historyData.length - 1) {
        this.$scope.testimonialIndex = 0
      } else {
        this.$scope.testimonialIndex += 1;
      }
      this.$scope.lastChange = new Date().getTime();
    }

    public nextJubi() {
      $("#jubiCarrousel").parent().removeClass("anim-to-right");
      $("#jubiCarrousel").parent().addClass("anim-to-left");
      if (this.$scope.jubiIndex >= this.$scope.jubiData.length - 1) {
        this.$scope.jubiIndex = 0;
      } else {
        this.$scope.jubiIndex += 1;
      }
      this.$scope.lastChangeJubi = new Date().getTime();
    }

    public previous() {
      $("#testimonialCarrousel").parent().removeClass("anim-to-left");
      $("#testimonialCarrousel").parent().addClass("anim-to-right");
      if (this.$scope.testimonialIndex < 1) {
        this.$scope.testimonialIndex = this.$scope.historyData.length - 1;
      } else {
        this.$scope.testimonialIndex -= 1;
      }
      this.$scope.lastChange = new Date().getTime();
    }

    public previousJubi() {
      $("#jubiCarrousel").parent().removeClass("anim-to-left");
      $("#jubiCarrousel").parent().addClass("anim-to-right");
      if (this.$scope.jubiIndex < 1) {
        this.$scope.jubiIndex = this.$scope.jubiData.length - 1;
      } else {
        this.$scope.jubiIndex -= 1;
      }
      this.$scope.lastChangeJubi = new Date().getTime();
    }

    public checkPageChange() {
      if (!this.$scope.historyData) return;
      if (new Date().getTime() - this.$scope.lastChange > this.waitTime) {
        this.next();
        this.$scope.lastChange = new Date().getTime();
      }
    }

    public checkPageChangeJubi() {
      if (!this.$scope.jubiData) return;
      if (new Date().getTime() - this.$scope.lastChangeJubi > this.waitTime) {
        this.nextJubi();
        this.$scope.lastChangeJubi = new Date().getTime();
      }
    }
    
  }
}